import { Flex, Avatar, Text, Badge, AvatarGroup, Box } from "@chakra-ui/react";

// Utils
import { openLinkInNewTab } from "utils";

// analytics
import { trackEvent } from "utils/firebase";
import { DEFI_CLICK } from "constants/analytics";

type Props = {
  icon: any;
  token1: string;
  token1Icon: any;
  token2: string;
  token2Icon: any;
  partnerName: string;
  link: string;
  apy: string;
  tvl: string;
  showTVL: boolean;
  token1IconWidth?: string;
  token1IconHeight?: string;
  token2IconWidth?: string;
  token2IconHeight?: string;
};

const DefiCard = ({
  icon,
  token1,
  token1Icon,
  token2,
  token2Icon,
  partnerName,
  link,
  apy,
  tvl,
  showTVL,
  token1IconWidth,
  token1IconHeight,
  token2IconWidth,
  token2IconHeight,
  ...rest
}: Props) => {
  const onClick = () => {
    openLinkInNewTab && openLinkInNewTab(link);
    trackEvent(DEFI_CLICK, {
      from: "Home",
      name: `${token1}/${token2}`,
      type: "Liquidity Pools",
    });
  };
  return (
    <Flex
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      border="1px solid #C9C9C9"
      boxShadow="0px 4px 12px rgba(0, 0, 0, 0.08)"
      borderRadius="0.5rem"
      p="1.5rem"
      textAlign="center"
      maxW="200px"
      position="relative"
      cursor="pointer"
      onClick={onClick}
      _dark={{
        bg: "brand.textBg",
        borderColor: "#424242",
      }}
      {...rest}
    >
      <Flex align="center" justify="center" mb="0.5rem">
        <Avatar h="40px" w="40px" name="platform" src={icon.src} bg="none" />
      </Flex>
      <Text fontSize="16px" mb="1rem" fontWeight="600">
        {partnerName}
      </Text>
      <Badge
        fontSize="10px"
        lineHeight="12px"
        bg="brand.defiPreview.bg"
        color="brand.defiPreview.text"
        borderRadius="12px"
        p="4px"
        mb="12px"
      >
        <Flex align="center" gap="4px" p="4px" fontSize="14px">
          <Text as="span" fontWeight="400">
            {showTVL ? "TVL" : "APY"}
          </Text>
          <Text as="span" fontWeight="600">
            {showTVL ? tvl : `${apy || "-"} %`}
          </Text>
        </Flex>
      </Badge>
      <Flex align="center" h="20px" gap="0.5rem" justify="center">
        <Box h="20px">
          <AvatarGroup spacing="-2" justifyContent="center" mb="0.5rem">
            <Avatar
              name={token1}
              src={token1Icon.src}
              zIndex="1"
              w={token1IconWidth || "20px"}
              h={token1IconHeight || "20px"}
              borderWidth="0"
              bgColor="transparent"
            ></Avatar>
            {token2Icon && (
              <Avatar
                name={token2}
                src={token2Icon.src}
                w={token2IconWidth || "20px"}
                h={token2IconHeight || "20px"}
                borderWidth="0"
                bgColor="transparent"
              ></Avatar>
            )}
          </AvatarGroup>
        </Box>
        <Text fontSize="12px" lineHeight="20px">
          {token1}
          {` / ${token2}`}
        </Text>
      </Flex>
    </Flex>
  );
};

export default DefiCard;
